export default __webpack_public_path__ + "static/media/sb-ICO-01.b7f74f4f.webp";